import React from 'react'
import UserForm from 'components/Forms/UserForm'

const Summary = () => {
  return <UserForm />
}

export default Summary
